import { Distribute, Spacer, Text } from '@loomhq/lens';
import React from 'react';

import { getCloudfrontURI } from '../../../utilities/avatar';
import { getShareVideoUrl } from '../../../utilities/video';
import { secondsToHumanReadableString } from '../../../../../shared/utilities/time';

import './styles.less';

function VideoReplyParentIndicator({ parentProperties }) {
  const { id, title, duration, ownerName, thumbnail, ownerThumbnail } =
    parentProperties;

  return (
    <a
      className="share-video-parent-indicator-container"
      target="_blank"
      rel="noopener noreferrer"
      href={getShareVideoUrl({ id })}
    >
      <div className="video-thumbnail">
        <img className="video-thumbnail" src={getCloudfrontURI(thumbnail)} />
        <div className="video-thumbnail-overlay" />
        <div className="video-thumbnail-overlay hover-info">
          <Text color="white">{secondsToHumanReadableString(duration)}</Text>
        </div>
      </div>
      <Spacer right={3} />
      <div className="video-title-and-owner">
        <div className="video-title">
          <Text hasEllipsis>
            Original Video{' '}
            <Text isInline fontWeight="medium">
              {title}
            </Text>
          </Text>
        </div>
        <Distribute alignment="center">
          <img
            src={getCloudfrontURI(ownerThumbnail.thumb)}
            className="video-owner-thumbnail"
          />
          <Spacer right={1} />
          <Text size="small">{ownerName}</Text>
        </Distribute>
      </div>
    </a>
  );
}

export default VideoReplyParentIndicator;
